import React from  'react';
import {connect} from 'react-redux';
// utils
import {Translations} from '../../../../utils/';
// constant
import {FORM_REFS} from '../../../../constants';
// restClient
import {aemHostClient, eapiClient} from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
//style
import './styles.css';

class CreateNewEchannelContact extends React.Component{
  constructor(props) {
    super(props)
    this.state={}
  }

  componentWillMount(){
    let apiURL = "/aemData/formData/json_create-contact";
    if(this.props.mode === "edit"){
      apiURL = apiURL.replace("create-", "edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      document.title =`${data.title} - ${'HSBC GLCM'}`;
      this.setState({formJson: data});
    });
  }

  getFormData = (formData) => {
    this.setState({formData});
  }

  onFormSubmit = (event, apiURL) => {
    var requestData = {
      ...this.state.formData,
      caseId: this.props.caseId
    };
    requestData.entityId = this.props.entityId;
    if(this.props.mode === 'edit') {
      apiURL = apiURL + "/" + this.state.formData.id;
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(apiURL, {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
    .then(({data}) => {
      var key = window.sessionStorage.getItem("getCurrentDropDown");
      window.sessionStorage.setItem('key'+ key, data.responseData.id);
      this.props.history.goBack();
    });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups(){
     let formData;
    if(this.props.currentEchannelContact !== undefined) {
      formData = {...this.props.currentEchannelContact};
    }else {
      formData = {};
    }
    const properties = {
      contactId: this.props.match.params.contactId,
      contactType: this.props.match.params.contactType,
      formData,
      editType: 'create-new-echannel-contact',
      pathname: this.props.history.location.pathname
    };
    if(this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined){
      return (
        <Dynamicform mode={this.props.mode}
        properties={properties}
        url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
        getFormData={this.getFormData}
        history={this.props.history}
        match={this.props.match}
        onFormSubmit={this.onFormSubmit}
        onFormCancel={this.onFormCancel}
        lang = {this.props.lang.currentLang.lang}
        translatedData ={this.props.lang.translatedData}
        flag={this.props.lang.currentLangFlag.flag}
        />
      );
    }
  }

  render(){
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : '';
    return(
      <div className="form-container">
      <div className="form-title">
      <h2 className="form-heading">
        {Translations(pageTitle.pageHeading,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </h2>
      <p className="form-required-desc">
        {Translations(pageTitle.descriptionText,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </p>
      </div>
      {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  let currentEchannelContact = undefined;
  if(props.match.params) {
    var {contactId} = props.match.params;
    if(contactId && state.persons.length > 0){
      state.persons.forEach(echannelContact => {
        if(echannelContact.id === contactId) {
          currentEchannelContact = echannelContact;
        }
      });
    }
  }
  return {
    currentEchannelContact,
    mode: currentEchannelContact !== undefined ? 'edit' : '',
    caseId:state.cases[state.currentProductEchannel.data.caseId].caseId,
    entityId: state.cases[state.currentProductEchannel.data.caseId].entityId,
    lang: state.lang
  };
}

export default connect(mapStateToProps)(CreateNewEchannelContact);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductEchannel/CreateNewEchannelContact.js